import { message, Tooltip } from "antd";
import {
  Table,
  TableHeader,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { DocumentDuplicateIcon, TrashIcon } from "@heroicons/react/24/outline";
import { VoiceDelete } from "./VoiceDelete";
import { CopyToClipboard } from "react-copy-to-clipboard";

function getVoiceId(voice) {
  const { voiceProvider, voiceSettings } = voice;

  if (voiceProvider === "cartesia") {
    return voiceSettings.cartesiaVoiceId;
  }

  if (voiceProvider === "elevenlabs") {
    return voiceSettings.elevenlabsVoiceId;
  }

  return "";
}

function VoicesTable(props) {
  const { voices, fetchVoices, isViewOnly } = props;
  const [open, setOpen] = useState({
    isOpen: false,
    item: null,
  });

  return (
    <>
      <Table className="">
        <TableHead className="p-8">
          <TableHeader>Name</TableHeader>
          <TableHeader>Preview</TableHeader>
          <TableHeader></TableHeader>
        </TableHead>
        {voices.length > 0 && (
          <TableBody>
            {voices.map((voice, idx) => {
              const { previewUrl, voiceName } = voice;
              const voiceId = getVoiceId(voice);

              return (
                <TableRow
                  key={idx}
                  className="hover:bg-gray-50"
                >
                  <TableCell>
                    <div>
                      <Tooltip title={voiceName}>
                        <p className="max-w-[200px] truncate font-semibold">
                          {voiceName}
                        </p>
                      </Tooltip>

                      {voiceId && (
                        <div className="flex items-start gap-x-2">
                          <p className="text-gray-400">{voiceId}</p>
                          <Tooltip title="Copy Voice ID">
                            <CopyToClipboard text={voiceId}>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  message.success("Copied");
                                }}
                              >
                                <DocumentDuplicateIcon className="size-4 text-gray-500 cursor-pointer hover:text-gray-700" />
                              </div>
                            </CopyToClipboard>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </TableCell>

                  <TableCell>
                    <audio
                      controls
                      className="mt-2"
                    >
                      <source
                        src={previewUrl}
                        type="audio/mp3"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  </TableCell>
                  <TableCell>
                    {!isViewOnly && (
                      <Button
                        outline
                        onClick={() => setOpen({ isOpen: true, item: voice })}
                      >
                        <TrashIcon />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
      {open.isOpen && (
        <VoiceDelete
          open={open.isOpen}
          item={open.item}
          fetchVoices={fetchVoices}
          onClose={() => setOpen({ isOpen: false, item: null })}
        />
      )}
    </>
  );
}

export { VoicesTable };
